import ApiService from './api-service';
import config from '../../config/index';

const setAccountingSoftwareNames = organisations =>
  organisations.map(organisation => {
    const accountingSoftware = config.accountingSoftware.find(software =>
      software.ids.includes(organisation.accountingSoftware),
    ) || {
      name: 'Other',
    };

    return {
      ...organisation,
      accountingSoftware: accountingSoftware.name,
    };
  });

const setStatus = organisations =>
  organisations.map(organisation => {
    let status = '';
    if (organisation.noChase) status = 'Paused';
    if (!organisation.noChase) status = 'Chasing';
    if (!organisation.isConnected) status = 'Disconnected';

    return {
      ...organisation,
      status,
    };
  });

const updateClientProperties = organisations => {
  const statusChanges = setStatus(organisations);
  return setAccountingSoftwareNames(statusChanges);
};

const formatScore = (data, score) => ({ ...data, score });

const ClientService = {
  async getClients(bundleId) {
    const res = await ApiService.baseEndpoint().get(`/bundles/${bundleId}`);
    const clients = updateClientProperties(res.organisations);
    return clients.map(c => ({
      ...c,
      healthscoreLoading: true,
    }));
  },

  async getHealthscores(clients) {
    try {
      const healthscores = await ApiService.baseEndpoint().get(
        `/healthscores`,
        {
          params: clients.reduce(
            (acc, client) => ({ ...acc, [client.ShortCode]: client.Name }),
            {},
          ),
        },
      );

      return clients.map((_, i, hsClients) => {
        const healthscore = healthscores[i];
        if (healthscore.hasOwnProperty('score')) {
          hsClients[i].healthscoreData = formatScore(
            healthscore,
            Math.round(healthscore.score),
          );
        } else if (healthscore.pending) {
          hsClients[i].healthscoreData = formatScore(
            healthscore,
            'isProcessing',
          );
        } else {
          hsClients[i].healthscoreData = formatScore({}, 'NA');
        }
        hsClients[i].healthscoreLoading = false;
        return hsClients[i];
      });
    } catch (error) {
      return clients.map((_, i, hsClients) => {
        hsClients[i].healthscoreData = formatScore({}, 'isProcessing');
        return hsClients[i];
      });
    }
  },
};

export default ClientService;
